export const selectCitySlug = (state) => state.city.data?.slug;
export const selectAirport = (state) => state.destination.data.airport;
export const selectEventId = (state) => state.event.data.id;
export const selectSearchRequest = (state) => state.searchRequest;
/*
    Below toFixed pattern is due to zoom/pan using different decimal depth than search, this normalizes it
    decimal place 3 === neighborhood, street precision per https://en.wikipedia.org/wiki/Decimal_degrees

    Below isn't defined initially so we needed to check for it
*/
export const selectSearchLatLon = (state) => ({
    latitude: state.search.searchCenterPostZoomOrPan?.latitude
        ? state.search.searchCenterPostZoomOrPan?.latitude.toFixed(3)
        : '',
    longitude: state.search.searchCenterPostZoomOrPan?.longitude
        ? state.search.searchCenterPostZoomOrPan?.longitude.toFixed(3)
        : '',
});
export const selectSearchRequestLatLon = (state) => ({
    latitude: Number(state.searchRequest.latitude).toFixed(3),
    longitude: Number(state.searchRequest.longitude).toFixed(3),
});
